import { Controller, useFormContext } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";

import { Label } from "abs-ui-components";
import { Input } from "abs-ui-components";
import { preventScientificNotation } from "../../../../../../services/utilities";

const CslipForm = ({ section, type }) => {
	const {
		control,
		formState: { errors },
	} = useFormContext();

	const sanitizeKey = (key) => {
		if (!key) return "";
		return key.replace(/\|/g, "").replace(/\./g, "_");
	};

	return (
		<>
			{section.sectionName === "Cslips" && (
				<MDBRow className="mt-4">
					{section?.fields?.map((formField, fieldIndex) => (
						<MDBCol
							md="3"
							className="pr-2 mt-3"
							key={`${formField.key}-${fieldIndex}`}
						>
							{formField.dataType === "decimal" && (
								<>
									<Label
										bold
										name={formField.fieldName}
										className="mb-1"
									/>
									<Controller
										name={
											sanitizeKey(formField.key)
										}
										control={control}
										defaultValue={
											type === "Edit"
												? formField.value || null
												: ""
										}
										render={({ field }) => {
											// Ensure field is defined before accessing properties
											if (!field) return null; // Return null if field is undefined

											return (
												<Input
													autoFocus={false}
													{...field} // Spread the field props from Controller
													className="inputHeight"
													type="number"
													step="any"
													onChange={(e) => {
														// Check if field.onChange is available before calling it

														field.onChange(e);
													}}
													value={field?.value ?? ""} // Safely use field.value or fallback to ''
													onKeyDown={(e) => {
														preventScientificNotation(e);
														// Prevent up and down arrow keys
														if (
															e.key === "ArrowUp" ||
															e.key === "ArrowDown"
														) {
															e.preventDefault();
														}
													}}
													onWheel={(e) => e.target.blur()}
												/>
											);
										}}
									/>
								</>
							)}
						</MDBCol>
					))}
				</MDBRow>
			)}
		</>
	);
};

export default CslipForm;
